
import { css } from 'lit';
export default css`
.cta-card {
  height: 100%;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(232, 194, 255, var(--tw-border-opacity));
  height: 100%;
}

  .cta-card__wrapper {
  display: flex;
}

  .cta-card__wrapper {
  height: 100%;
}

  .cta-card__wrapper {
  flex-direction: column;
}

  .cta-card__wrapper {
    padding-top: 36px;
  }

  .cta-card__image {
  position: relative;
}

  .cta-card__image {
    margin-bottom: 0;
  }

  .cta-card__title {
  margin-left: 2rem;
  margin-right: 2rem;
}

  .cta-card__title {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

  @media (min-width: 768px) {

  @media (min-width: 768px) {

    .cta-card__title {
      margin-left: 1.5rem;
      margin-right: 1.5rem;
    }
  }
}

  @media (min-width: 1024px) {

  .cta-card__title {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

  .cta-card__title {
    margin-top: 23px;
  }

  .cta-card__body-text {
  margin-left: 2rem;
  margin-right: 2rem;
}

  .cta-card__body-text {
  font-weight: 400;
}

  .cta-card__body-text {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

  @media (min-width: 768px) {

  .cta-card__body-text {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

  @media (min-width: 1024px) {

  .cta-card__body-text {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

  .cta-card__body-text {
    margin-top: 8px;
  }

  @media (min-width: 768px) {

  .cta-card__body-text {
      margin-top: 11px
  }
    }

  @media (min-width: 1024px) {

  .cta-card__body-text {
      margin-top: 14px
  }
    }

  .cta-card__link {
  margin-bottom: 0px;
}

  .cta-card__link {
  margin-right: 0px;
}

  .cta-card__link {
  margin-top: auto;
}

  .cta-card__link {
  display: flex;
}

  .cta-card__link {
  align-content: flex-end;
}

  .cta-card__link {
  justify-content: flex-end;
}

  .cta-card__link {
    padding-top: 26px;
  }

  .cta-card__link-text {
  margin-right: 0.75rem;
}

  .cta-card__link-text {
  align-self: center;
}

  .cta-card__link-text {
  text-align: right;
}

  .cta-card__link-text {
  font-size: 1.125rem;
}

  .cta-card__link-text {
  font-weight: 700;
}

  .cta-card__link-text {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .cta-card__link-text {
    line-height: 22px;
  }

  @media (min-width: 1024px) {

  .cta-card__link-text {
      line-height: 30px
  }
    }

  .cta-card__link-icon {
  display: flex;
}

  .cta-card__link-icon {
  align-items: center;
}

  .cta-card__link-icon {
  justify-content: center;
}

  .cta-card__link-icon {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .cta-card__link-icon {
  padding: 1rem;
}

  .cta-card__link-icon {
  text-align: center;
}

  .cta-card__link-icon {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .cta-card__wrapper:hover {
  --tw-shadow: 0 0 36px 0px rgba(0,0,0,0.16);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .cta-card__wrapper:hover .cta-card__link-text {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .cta-card__wrapper:hover .cta-card__link-icon {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

  .cta-card--has-image .cta-card__wrapper {
      padding-top: 0;
    }

  .cta-card--people-grid .cta-card {
      border: 0;
    }

  .cta-card--people-grid .cta-card__image {
      margin-bottom: 2rem;
    }

  .cta-card--people-grid .cta-card__link {
      padding-top: 0;
    }
.btn__icon {
  margin-left: 2px;
  display: inline-block;
  height: 1rem;
  width: 1rem;
}
`;